import { TOUR_TRANSLATIONS } from "../translations"

export const getSosStatusSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="sos-status-filters"]',
            title: t.sosStatusFilters.title,
            content: t.sosStatusFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="sos-status-table"]',
            title: t.sosStatusTable.title,
            content: t.sosStatusTable.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.sosStatusScoreMap.title,
            content: t.sosStatusScoreMap.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'sos-status-table', closeOnLeave: true },
        },
    ]
}
